<script setup lang="ts">
// Global snackbar driven by the main Pinia store's actions. Extracted from the two
// layouts, which each carried their own copy of this markup + store wiring.
import type { Message } from "~/stores";

const snackbar = ref(false)
const message = ref<Message>({ content: '', status: '' })

const store = useMainStore()
store.$onAction(({ after }) => {
  after((result) => {
    message.value = result as Message
    snackbar.value = true
  })
})
</script>

<template>
  <v-snackbar
      :id="message?.content"
      v-model="snackbar"
      multi-line
      :timeout="5000"
      :color="message?.status"
  >
    <template v-if="message.content !== ''">
      {{ message.content }}
    </template>

    <template #actions>
      <v-btn
          color="black"
          variant="text"
          @click="snackbar = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
